import React from 'react';
import { Button, Modal, ModalHeader, Input } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import CardBox from 'components/CardBox';
import FormErrors from 'components/formErrors/FormErrors';
import { isNameValid, isValueEntered, isNumberValid } from 'services/Validation';
import { isDateBefore } from 'services/DateService';
import { formatDateDefault } from 'services/DateFormatters';

class ProjectAdd extends React.Component {
    constructor(props) {
        super(props);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);

        const {
            id,
            orgid,
            thumb,
            name,
            description,
            startDate,
            endDate,
            jiraProjectAttributes,
            costImplPriorityParams,
            busValPriorityParams,
            weight,
            budget,
            initiative,
            businessValue,
            starred,
            selected,
            frequently
        } = props.project;
        this.state = {
            id,
            orgid,
            thumb,
            name,
            description,
            startDate,
            endDate,
            jiraProjectAttributes,
            costImplPriorityParams,
            busValPriorityParams,
            weight,
            budget,
            initiative,
            businessValue,
            starred,
            selected,
            frequently,
            nameValid: isNameValid(name),
            startDateValid: isValueEntered(startDate),
            endDateValid: isValueEntered(endDate),
            budgetValid: isNumberValid(budget),
            formErrors: { name: '', startDate: '', endDate: '', dates: '', budget: '' },
            datesValid: false,
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    handleNumberInput = (e) => {
        const name = e.target.name;
        const value = parseInt(e.target.value);
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let startDateValid = this.state.startDateValid;
        let endDateValid = this.state.endDateValid;
        let budgetValid = this.state.budgetValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            case 'startDate':
                startDateValid = isValueEntered(value);
                fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
                break;
            case 'endDate':
                endDateValid = isValueEntered(value);
                fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
                break;
            case 'budget':
                budgetValid = isNumberValid(value);
                fieldValidationErrors.budget = budgetValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
            startDateValid: startDateValid,
            endDateValid: endDateValid,
            budgetValid: budgetValid,
        }, this.validateForm);
    }

    validateForm() {
        const datesAreValid = this.datesValid();
        this.setState({ formValid: this.state.nameValid && datesAreValid && this.state.budgetValid });
    }

    datesValid() {
        const { startDate, endDate } = this.state;
        let fieldValidationErrors = this.state.formErrors;
        if (isValueEntered(startDate) && isValueEntered(endDate)) {
            if (isDateBefore(endDate, startDate)) {
                fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
                this.setState({ formErrors: fieldValidationErrors });
                return false;
            }
            fieldValidationErrors.dates = '';
            this.setState({ formErrors: fieldValidationErrors });
            return true;
        }
        return false;
    }

    handleStartDateChange(selectedDay) {
        this.setState({ startDate: selectedDay },
            () => { this.validateField('startDate', selectedDay); });
    }

    handleEndDateChange(selectedDay) {
        this.setState({ endDate: selectedDay },
            () => { this.validateField('endDate', selectedDay); });
    }

    render() {
        const { onSaveProject, showProjectLoader, onProjectClose, open, project, initiatives } = this.props;
        const { id,
            orgid,
            name,
            description,
            startDate,
            endDate,
            jiraProjectAttributes,
            costImplPriorityParams,
            busValPriorityParams,
            weight,
            budget,
            initiative,
            businessValue,
            starred,
            selected,
            frequently
        } = this.state;
        const isNew = project.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onProjectClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="project.addProject" /> :
                        <IntlMessages id="project.saveProject" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onProjectClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src='assets/images/project-1_225_225.jpg' />
                        </div>
                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>
                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                            <input type="text" className={`form-control mb-2 ${name ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                            <input type="text" className="form-control mb-2"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={description} name="description"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.budget" />}</h3>
                            <Input type="number" className={`form-control mb-2 ${budget ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleNumberInput(event)}
                                defaultValue={budget} name="budget"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.initiative" />}</h3>
                            <Input type="select" name="initiative" id="initiativeSelect" onChange={(event) => this.handleUserInput(event)}>
                                <option key='emptySelect' value=''>-- select initiative --</option>
                                {initiatives.map((initiative) => {
                                    return <option key={initiative.id} value={initiative.id}>{initiative.name}</option>;
                                })}
                            </Input>
                            <h3 className="card-heading mt-2">{<IntlMessages id="label.startDate" />}</h3>
                            <div className={`form-control ${startDate ? 'is-valid' : 'is-invalid'}`}>
                                <DayPickerInput
                                    value={formatDateDefault(startDate)}
                                    onDayChange={this.handleStartDateChange}
                                    dayPickerProps={{
                                        selectedDays: new Date(startDate),
                                    }}
                                />
                            </div>
                            <h3 className="card-heading mt-2">{<IntlMessages id="label.endDate" />}</h3>
                            <div className={`form-control ${endDate ? 'is-valid' : 'is-invalid'}`}>
                                <DayPickerInput
                                    value={formatDateDefault(endDate)}
                                    onDayChange={this.handleEndDateChange}
                                    dayPickerProps={{
                                        selectedDays: new Date(endDate),
                                    }}
                                />
                            </div>
                            <h3 className="card-heading mt-2">{<IntlMessages id="project.projectBusinessValueIndicator" />}</h3>
                            <Input type="text" className="form-control"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={businessValue} name="businessValue"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showProjectLoader();
                        onProjectClose();
                        onSaveProject(
                            {
                                'id': id,
                                'orgid': orgid,
                                'name': name,
                                'description': description,
                                'startDate': startDate,
                                'endDate': endDate,
                                'jiraProjectAttributes': jiraProjectAttributes,
                                'costImplPriorityParams': costImplPriorityParams,
                                'busValPriorityParams': busValPriorityParams,
                                'weight': weight,
                                'budget': budget,
                                'initiative': initiative,
                                'businessValue': businessValue,
                                'starred': starred,
                                'selected': selected,
                                'frequently': frequently,
                                'thumb': null
                            });
                        this.setState({
                            id: '',
                            orgid: '',
                            name: '',
                            description: '',
                            startDate: '',
                            endDate: '',
                            budget: '',
                            initiative: '',
                            businessValue: '',
                            starred: false,
                            selected: false,
                            frequently: false,
                            thumb: null,
                            formErrors: { name: '', startDate: '', endDate: '', dates: '', budget: '' },
                            datesValid: false,
                            formValid: false,
                        });

                    }}>
                        {isNew ? <IntlMessages id="project.addProject" /> :
                            <IntlMessages id="project.saveProject" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default ProjectAdd;


// WEBPACK FOOTER //
// ./components/Agile/project/projectAdd/index.js